import React from "react";
import google from "../../../img/google.svg";
import { useSignInWithGoogle } from "react-firebase-hooks/auth";
import { auth } from "../../../firebase.init";
import { useLocation, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import axios from "axios";

const SocialLogin = () => {
  const [signInWithGoogle, user, loading, error] = useSignInWithGoogle(auth);
  const navigate = useNavigate();
  const location = useLocation();
  let from = location.state?.from?.pathname || "/";
  let errorElement;
  
  const tokenFung=async(user)=>{    
    const socialEmail = user?._tokenResponse?.email;
    
    const { data } =await axios.post(
      "https://rocky-ravine-79485.herokuapp.com/login",
      { email:socialEmail }
    );
    localStorage.setItem("token", data.accessToken);
  }
  if (user) {
    navigate(from, { replace: true });
    tokenFung(user)
  }
  if (error) {
    errorElement = <p className="text-danger">Error: {error?.message}</p>;
  }
  if (loading) {
    return <Spinner animation="border" variant="success" />;
  }
  return (
    <div>
      <button
        onClick={() => signInWithGoogle()}
        style={{ background: "#41976E" }}
        className="btn text-white align-items-center d-flex"
      >
        <img
          className="bg-white"
          src={google}
          alt=""
          style={{
            border: "2px solid #fff",
            padding: "2px",
            width: "28px ",
            marginRight: "10px",
          }}
        />
        Signup With Google
      </button>
    </div>
  );
};

export default SocialLogin;
